<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "dealers",
    cardSetLink: "dealers",
    item: null,
    fields: [
    {
      col:' col-12 col-md-12',
      key: "type",
      label: "Тип компании",
      type: "static_radio",
      items: [
        { id: 'op', title: "ИП" },
        { id: 'llc', title: "ООО" },
      ],
    },

      {
        col: ' col-12 col-md-12',
        key: "owner_name",
        label: "ФИО контактное",
        type: "field",
        textType: "text",
      },
      {
        col: ' col-12 col-md-6',
        key: "name",
        label: "Название компании",
        type: "field",
        textType: "text",
      },
      {
        col: ' col-12 col-md-6',
        key: "phone",
        label: "Контакнтный номер",
        type: "field",
        textType: "text",
      },
      {
        col: ' col-12 col-md-6',
        key: "email",
        label: "Контакнтный email",
        type: "field",
        textType: "text",
      },
      {
        col: ' col-12 col-md-6',
        key: "oked",
        label: "ОКЭД компании",
        type: "field",
        textType: "text",
      },
      {
        col: ' col-12 col-md-6',
        key: "tin",
        label: "ИНН компании",
        type: "field",
        textType: "text",
      },
      {
        col: ' col-12 col-md-6',
        key: "tax_percent",
        label: "Процент НДС",
        type: "field",
        textType: "text",
      },

      {
        col: ' col-12 col-md-12',
        key: "activity",
        label: "Деятельность компании",
        type: "field",
        textType: "text",
      },
      {
        col: ' col-12 col-md-12',
        key: "legal_address",
        label: "Юридический адрес компании",
        type: "field",
        textType: "text",
      },
      {
        col: ' col-12 col-md-6',
        key: "founders_count",
        label: "Количество учредителей",
        type: "field",
        textType: "number",
      },
      {
        col: ' col-12 col-md-6',
        key: "foundation_at",
        label: "Дата основания компании	",
        type: "field",
        textType: "date",
      },
  
      {
        col: ' col-12 col-md-12',
        key: "director_name",
        label: "ФИО	директора",
        type: "field",
      },
      {
        col: ' col-4',
        key: "director_passport_series",
        label: "Серия паспорта директора",
        type: "field",
      },
      {
        col: ' col-8',
        key: "director_passport_id",
        label: "Номер паспорта директора",
        type: "field",
      },
      {
        col: ' col-12',
        key: "director_passport_issued_by",
        label: "Кем выдан паспорт директора	",
        type: "field",
      },

      {
        col: ' col-12 col-md-12',
        key: "chief_accountant_name",
        label: "ФИО  бухгалтера",
        type: "field",
      },
      {
        col: ' col-4',
        key: "chief_accountant_passport_series",
        label: "Серия паспорта  бухгалтера",
        type: "field",
      },
      {
        col: ' col-8',
        key: "chief_accountant_passport_id",
        label: "Номер паспорта  бухгалтера",
        type: "field",
      },
      {
        col: ' col-12',
        key: "chief_accountant_passport_issued_by",
        label: "Кем выдан паспорт  бухгалтера",
        type: "field",
      },

      {
        col: ' col-12',
        key: "bank_name",
        label: "Название банка",
        type: "field",
      },
      {
        col: ' col-12',
        key: "bank_account",
        label: "Расчётный счёт",
        type: "field",
      },
      {
        col: ' col-12 col-md-6',
        key: "bank_tin",
        label: "ИНН банка	",
        type: "field",
      },
      {
        col: ' col-12 col-md-6',
        key: "bank_mfo",
        label: "МФО банка",
        type: "field",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    pushLang: pushLang,
    async updateItem() {
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>

</style>
